<template>
  <section
    v-if="item.length > 0"
    class="module dt-like"
  >
    <h3>{{ hobby_title }}</h3>
    <template v-for="(value, index) in item">
      <ul
        :key="index"
        class="dt-like-list"
      >
        <li
          v-for="(v, i) in truncate(value)"
          :key="i"
        >
          <a
            :href="v.url"
            :uigs="'tiny_out_hobby_' + (index * 9 + i) + '_p'"
            :title="v.name"
          >
            <div class="dt-like-img">
              <div :class="[spver === 1 ? 'default-film' : 'default-sogou']">
                <img
                  v-if="isSpider"
                  :src="checkHttps(v.v_picurl)"
                  :alt="v.name + '剧照'"
                >
                <img
                  v-else
                  v-lazy="checkHttps(v.v_picurl)"
                  :alt="v.name + '剧照'"
                >
              </div>
              <span class="tag-mark">{{ v.score }}</span>
            </div>
            <p class="dt-like-name">{{ v.name }}</p>
          </a>
        </li>
      </ul>
      <div
        v-if="index === 0"
        :key="index"
        style="padding: 0 14px"
      >
        <ExtAdv
          :adv-name="'like_' + index"
          mid="2392"
          tplid="103"
          w="680"
          h="410"
        />
      </div>
      <div
        v-else-if="index === 1"
        :id="'hobby_inside_' + index"
        :key="index"
        class="hobby_inside_ad _sogou_wap_ad"
      />
      <div
        v-else-if="index === 2"
        :key="index"
        style="padding: 0 14px"
      >
        <ExtAdv
          :adv-name="'like_' + index"
          mid="2400"
          tplid="103"
          w="680"
          h="410"
        />
      </div>
    </template>
  </section>
</template>

<script>
import 'intersection-observer';

import { mapState } from 'vuex';

import ExtAdv from '../../common/components/Adv.vue';
import { checkHttpsUrl, getSpver } from '../../common/js/util';

export default {
  name: 'Like',
  components: {
    ExtAdv,
  },
  data() {
    return {
      loadExtAdv: false,
      ad_io: null,
      addSogouJsInFs: false,
    };
  },
  computed: {
    ...mapState('summary', ['itemData']),
    item() {
      const items = this.itemData.hobby_item;
      const newArray = [];
      if (items && items.length > 0) {
        let index = 0;
        const sublength = 9;
        while (index < items.length) {
          newArray.push(items.slice(index, (index += sublength)));
        }
      }
      return newArray;
    },
    hobby_title() {
      return this.itemData.hobby_title;
    },
    spver() {
      return getSpver({ spver: this.$route.query.spver, returnType: 'num' }) || 0;
    },
    isSpider() {
      return this.itemData.isSpiderUA;
    },
  },
  mounted() {
    this.initExtAdv();
    const self = this;
    window.addEventListener('scroll', () => {
      const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      if (document && document.body && scrollTop > 0 && !self.loadExtAdv) {
        self.addQQScript();
        self.loadExtAdv = true;
      }
    });
  },
  methods: {
    truncate(arr) {
      // 最后一行若是文字且少于3个则不展示
      const leng = arr.length;
      if (leng % 3 === 0) {
        return arr;
      }
      const n = Math.floor(leng / 3);
      return arr.slice(0, 3 * n);
    },
    checkHttps(url) {
      return checkHttpsUrl(url);
    },
    addScript(text) {
      const s = document.createElement('script');
      s.innerHTML = text;
      document.body.appendChild(s);
    },
    initExtAdv() {
      const si = `
                //文字浮层（上文下图）
                TencentGDT.push({
                    placement_id: '6020742689858632',
                    app_id:'1107895383',
                    type: 'native',
                    count:3,//拉取广告的数量，必填，默认是3，最高支持10
                    onComplete: function(obj){
                        if(obj && obj.constructor === Array){
                            //window.hobby_inside_1 = obj[0];
                            window.TencentGDT.NATIVE.renderAd(obj[0], 'hobby_inside_1');
                        }
                    }
                });
                `;
      this.addScript(si);
    },
    addSogouScript() {
      const str = `
                    if(window.sogou_un && window.sogou_un.length>0){
                        setTimeout(function() {
                            var _doc=document,
                                _head=_doc.getElementsByTagName('head')[0],
                                _script=_doc.createElement('script');
                            _script.async=true;
                            _script.src='https://theta.sogoucdn.com/wap/js/aw.js';
                            _head && _head.insertBefore(_script,_head.firstChild);
                        },0);
                    }
                    `;
      this.addScript(str);
    },
    addQQScript() {
      const str = `
                    if(TencentGDT && TencentGDT.length>0){
                        setTimeout(function() {
                            var doc=document,
                                s=doc.createElement('script');
                            s.async=true;
                            s.src='//qzs.qq.com/qzone/biz/res/i.js';
                            doc.body.appendChild(s);
                        },0);
                    }
                    `;
      this.addScript(str);
    },
    obAdStatus() {
      const adDom = document.querySelectorAll('._sogou_wap_ad');
      const self = this;
      if (!self.ad_io) {
        self.ad_io = new IntersectionObserver((entries) => {
          entries.forEach((item) => {
            if (item.isIntersecting) {
              const iName = item.target.id;
              if (window[iName] && window.TencentGDT) {
                window.TencentGDT.NATIVE.renderAd(window[iName], iName);
              }
              self.ad_io.unobserve(item.target);
            }
          });
        });
      }
      for (const md of adDom) {
        self.ad_io.observe(md);
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';

.dt-like {
  margin-top: 30px;
}

.dt-like-list {
  font-size: 0;
  padding: 0 14px;

  li {
    display: inline-block;
    width: 32%;
    margin-right: 2%;
    vertical-align: text-top;

    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  a {
    display: block;
  }
}

.dt-like-img {
  width: 100%;
  padding-top: 140%;
  border-radius: 5px;
  overflow: hidden;
  position: relative;

  &:after {
    content: '';
    width: 100%;
    height: 50px;
    position: absolute;
    bottom: 0;
    left: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  > span {
    position: absolute;
    display: block;
  }

  .tag-mark {
    right: 8px;
    bottom: 10px;
    color: #fece32;
    font-size: 13px;
    z-index: 2;
    font-weight: bold;

    &:first-letter {
      font-size: 19px;
    }
  }
}

.dt-like-img-playlist {
  width: 100%;
  padding-top: 116%;
  border-radius: 5px;
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    left: 0;
    top: 0;
  }

  .img-one {
    position: absolute;
    width: 73%;
    height: 100%;
    border-radius: 5px;
    left: 0;
    top: 0;
    z-index: 3;
    overflow: hidden;
  }

  .img-two {
    position: absolute;
    width: 73%;
    height: 95%;
    border-radius: 5px;
    left: 16px;
    bottom: 0;
    z-index: 2;
    overflow: hidden;

    &:after {
      content: '';
      width: 100%;
      height: 100%;
      background: #f5f5f5;
      opacity: 0.25;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .img-three {
    position: absolute;
    width: 73%;
    height: 88%;
    border-radius: 5px;
    left: 30px;
    bottom: 0;
    z-index: 1;
    overflow: hidden;

    &:after {
      content: '';
      width: 100%;
      height: 100%;
      background: #f5f5f5;
      opacity: 0.6;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .tag-playlist {
    height: 18px;
    line-height: 18px;
    background: #fff;
    position: absolute;
    right: 0;
    bottom: 10px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    font-size: 11px;
    color: #222;
    z-index: 3;
    padding: 0 5px;
    font-weight: bold;
  }
}

.dt-like-name {
  @include line-clip(2);
  line-height: 21px;
  font-size: 15px;
  color: #000;
  margin: 6px 0 22px;
}

.dt-like-tags {
  padding: 0 14px;
  font-size: 0;
  margin-bottom: 15px;

  li {
    display: inline-block;
    width: 32%;
    margin-right: 2%;

    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  a {
    @include line-clip(1);
    display: block;
    height: 35px;
    line-height: 35px;
    border-radius: 5px;
    background: #f5f5f5;
    text-align: center;
    font-size: 13px;
    color: #222;
    padding: 0 10px;
    margin-bottom: 10px;
  }
}

.dt-like-ad {
  margin: 0 14px;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  height: 192px;
  margin-bottom: 27px;

  &.small {
    height: 45px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    vertical-align: bottom;
  }

  p {
    width: 100%;
    height: 32px;
    line-height: 32px;
    @include line-clip(1);
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    position: absolute;
    left: 0;
    bottom: 0;
    text-indent: 10px;
    font-size: 15px;
  }

  button {
    border: none;
    width: 28px;
    height: 28px;
    position: absolute;
    right: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.7);

    &:before {
      content: '';
      width: 1px;
      height: 14px;
      background: #fff;
      transform: rotate(45deg);
      @extend %-absolute-center;
    }

    &:after {
      content: '';
      width: 1px;
      height: 14px;
      background: #fff;
      transform: rotate(-45deg);
      @extend %-absolute-center;
    }
  }
}
</style>
